/**
 * 正規表現の特殊文字をescapeする
 */
export const escapeRegExpSpecialCharacters = (word: string): string => {
  const specialCharacters = /([.+*?^$()[\]{}|\\])/g;
  return word.replace(specialCharacters, '\\$&');
};
